import React from 'react';

import type { CodeBlockSuggestion } from '@aline/common';
import { IconButton } from '@mui/material';
import clsx from 'clsx';
import { ChevronDownIcon } from 'lucide-react';
import { $chatThreadState } from 'src/components/ai/chat/chat-state';
import { makeStyles } from 'tss-react/mui';

export const useVisibilityButtonStyles = makeStyles()(_theme => ({
  headerIcon: {
    height: 18,
    strokeWidth: 1.5,
    width: 18,
  },
  visibilityButtonUp: {
    transform: 'rotate(180deg)',
  },
}));

export function VisibilityButton({
  isSuggestionVisible,
  suggestion,
}: {
  isSuggestionVisible: boolean;
  suggestion: CodeBlockSuggestion;
}) {
  const { classes } = useVisibilityButtonStyles();
  const handleToggleVisibility = (e: React.MouseEvent) => {
    e.stopPropagation();
    $chatThreadState.suggestionVisibilityByGroupId[suggestion.groupId] = isSuggestionVisible
      ? 'hidden'
      : 'visible';
  };

  return (
    <IconButton size="small" onClick={handleToggleVisibility}>
      <ChevronDownIcon
        className={clsx(classes.headerIcon, isSuggestionVisible && classes.visibilityButtonUp)}
      />
    </IconButton>
  );
}
